import React, { memo } from 'react';
import styled from 'styled-components';
import { Container, Typography } from '@mui/material';
import OptimizedImage from './OptimizedImage';

const HeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  overflow: hidden;
`;

const BackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

const BackgroundImage = styled(OptimizedImage)`
  width: 100%;
  height: 100%;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

const ContentWrapper = styled(Container)`
  position: relative;
  z-index: 2;
  width: 100%;
`;

const HeroHeader = memo(({ title, backgroundImage }) => {
  return (
    <HeroContainer>
      <BackgroundWrapper>
        <BackgroundImage src={backgroundImage} alt="" height="100%" />
      </BackgroundWrapper>
      <Overlay />
      <ContentWrapper maxWidth="xl">
        <Typography 
          variant="h1" 
          sx={{ 
            color: 'white',
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          {title}
        </Typography>
      </ContentWrapper>
    </HeroContainer>
  );
});

HeroHeader.displayName = 'HeroHeader';

export default HeroHeader; 